<template>
  <div
    v-if="options"
    v-loading="isLoading"
    :class="['grid-filter check-box', options.classes, {'is-clear': isClear}]"
    :style="options.styles">
    <el-form-item
      :label="fieldLabel"
      class="material-style"
    >
      <el-select
        v-model="model"
        :placeholder="options.placeholder"
        :size="options.size"
        @change="debounceHandleChange"
        @clear="handleReset"
        clearable>
        <el-option
          v-for="item in source"
          :key="item[options.option.value]"
          :label="getOptionLabel(item)"
          :value="item[options.option.value]">
        <span
          v-if="typeof options.option.template === 'function'"
          v-html="options.option.template(item)"/>
        <span v-else>
          <div class="option-check-box-select">
            <span :class="['el-checkbox__input', {'is-checked': isSelectedOption(item[options.option.value])}]">
              <span class="el-checkbox__inner"></span>
            </span>
            <span class="el-checkbox__label">
              {{getOptionLabel(item)}}
            </span>
          </div>
        </span>
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
import mixins from '../mixins'

export default {
  name: 'FilterCheckBox',
  mixins: [mixins],
  props: {
    config: { type: Object },
    place: { type: String, default: 'column' }
  },
  data () {
    return {
      model: '',
      source: [],
      debounceHandleChange: null
    }
  },
  computed: {
    isClear () {
      return !this.model
    },
    fieldLabel () {
      return this.checkJsTemplate(this.config.label)
    }
  },
  created () {
    this.debounceHandleChange = this.$_.debounce(this.handleChange, 100)
  },
  methods: {
    isSelectedOption (value) {
      return this.model === value
    },
    getOptionLabel (item) {
      if (typeof item.template === 'function') {
        return item.template(item, this)
      } else {
        return item[this.options.option.label]
      }
    },
    MODEL () {
      return {
        // eslint-disable-next-line
        valueTemplate: '${data.field} == ${data.value == "true"}',
        value: '',
        defaultValue: '',
        dataSource: [{ label: this.L10n('yes'), value: 'true' }, { label: this.L10n('no'), value: 'false' }],

        placeholder: this.L10n('select'),
        classes: '',
        styles: { minWidth: '30rem' },
        size: '',

        option: {
          label: 'label',
          value: 'value',
          template: null
        }
      }
    },
    parseConfig (Options) {
      this.handle('parseStart')
      // reset data
      this.options = null
      this.model = null
      this.source = []
      this.isLoading = true
      // update options
      this.options = this.$_.merge(this.MODEL(), this.config.options, Options || {})
      // set default value
      this.model = this.options.defaultValue;
      ['placeholder', 'dataSource'].forEach(key => {
        this.options[key] = this.checkEs6AndRun(this.options[key])
      })
      this.parseOptionsTemplate()
      // TODO: NEED STRONG APPLY DATA SOURCE OPTION, BECAUSE ARRAY(S) is MERGED
      if (Options && Options.dataSource) {
        if (typeof Options.dataSource === 'object') {
          this.options.dataSource = this.$_.merge({}, Options.dataSource)
        } else if (Array.isArray(Options.dataSource)) {
          this.options.dataSource = [...Options.dataSource]
        } else {
          this.options.dataSource = Options.dataSource
        }
      }
      // update filters query
      this.updateRendered()
      this.handle('parseEnd')
      this.createSource()
      this.setDefaultValue()
    },
    updateRendered () {
      this.result = this.options.value
      this.resultHuman = ''
      if (this.model) {
        this.result = this.valueTemplate({ field: this.config.field, value: this.model }, this)
        this.resultHuman = null
      } else {
        this.result = ''
        this.resultHuman = null
      }
    },
    createSource () {
      if (typeof this.options.dataSource === 'function') {
        this.parseSource(this.options.dataSource(null, this))
      } else if (Array.isArray(this.options.dataSource)) {
        this.parseSource(this.options.dataSource)
      }
    },
    parseSource (Items) {
      let items = [...Items]
      // set model
      this.source = items
      // TODO: NOTE#1 In next version need parse value from ARRAY and String
      // if (this.source.length) this.setValue(this.options.value, true)
      this.updateRendered()
      this.isLoading = false
      this.handle('init')
    },
    // HANDLERS
    handleChange () {
      this.updateRendered()
      this.handle('change')
    },
    handleReset () {
      this.model = ''
      this.handleChange()
    },
    handleClear () {
      this.model = ''
      this.handleChange()
    },
    /**
     * @name resetField
     * @desc Method for reset field data. It emits, when user click button 'clear-filter'
     */
    resetField () {
      this.model = ''
      this.updateRendered()
      this.handle('resetField')
    },
    handle (Type) {
      this.$emit('handle', {
        id: this.config.id,
        type: Type,
        value: this.result,
        rendered: this.resultHuman
      })
    }
  }
}
</script>

<style lang="stylus">
  .el-select-dropdown {
    .option-check-box-select__label{
      display flex
      align-items center
      &::before{
        content ''
        display inline-block
        width 1.8rem
        height 1.8rem
        border 1px solid #DCDFE6
        border-radius 2px
        margin-right 1rem
      }
    }
  }
</style>
